import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import statuses from 'data/policy_statuses';

export default function BaseInfo({ policy }) {
  const policyStatus = statuses.find((status) => status.value === policy.attributes.status).label;

  return (
    <Row>
      <Col xs="10" lg="6" xl="4">
        <Row className="my-2">
          <Col className="fw-light">
            Policy Number:
          </Col>

          <Col className="fw-semibold">
            {policy.attributes.number}
          </Col>
        </Row>

        <Row className="my-2">
          <Col className="fw-light">
            Effective Date:
          </Col>

          <Col className="fw-semibold">
            {policy.attributes.original_effective_date_formatted}
          </Col>
        </Row>

        <Row className="my-2">
          <Col className="fw-light">
            Renewal Date:
          </Col>

          <Col className="fw-semibold">
            {policy.attributes.combine_renewal_date_formatted}
          </Col>
        </Row>

        <Row className="my-2">
          <Col className="fw-light">
            Status:
          </Col>

          <Col className="fw-semibold">
            {policyStatus}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

BaseInfo.propTypes = {
  policy: PropTypes.object.isRequired,
};
